module.exports = __webpack_public_path__ + "static/media/pin_orange.5c6189cf.svg";